/* eslint-disable react/prop-types */
import React from 'react';

export const Comment = ({ size = 24, color = '#64748B' }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5878 10.2966C13.1128 10.2966 12.7262 9.90991 12.7262 9.43491C12.7262 8.95991 13.1128 8.57238 13.5878 8.57238C14.0628 8.57238 14.4503 8.95991 14.4503 9.43491C14.4503 9.90991 14.0628 10.2966 13.5878 10.2966ZM10.2495 10.2966C9.77451 10.2966 9.38784 9.90991 9.38784 9.43491C9.38784 8.95991 9.77451 8.57238 10.2495 8.57238C10.7253 8.57238 11.112 8.95991 11.112 9.43491C11.112 9.90991 10.7253 10.2966 10.2495 10.2966ZM6.91116 10.2966C6.43616 10.2966 6.04949 9.90991 6.04949 9.43491C6.04949 8.95991 6.43616 8.57238 6.91116 8.57238C7.38699 8.57238 7.77366 8.95991 7.77366 9.43491C7.77366 9.90991 7.38699 10.2966 6.91116 10.2966ZM14.4687 3.04321H6.03366C4.10866 3.04321 2.54199 4.60905 2.54199 6.53405V12.2974C2.54199 14.2216 4.10866 15.7882 6.03366 15.7882H6.92366C7.34283 15.7882 7.75283 15.9574 8.04699 16.2532L9.23201 17.4382C9.50451 17.7099 9.86617 17.8607 10.2512 17.8607C10.6353 17.8599 10.9978 17.7099 11.2687 17.4382L12.4537 16.2541C12.7537 15.9541 13.1537 15.7882 13.5778 15.7882H14.4687C16.3928 15.7882 17.9587 14.2216 17.9587 12.2974V6.53405C17.9587 4.60905 16.3928 3.04321 14.4687 3.04321Z"
      fill={color}
    />
  </svg>
);
